import FunctionUtils from 'utils/FunctionUtils';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { CommonHttp } from '../services/common.http';
import { actions } from './slice';
import { CommonGetAction } from './modal';
import { getActionOptions } from 'utils/reduxUtil';

const commonHttp = new CommonHttp();
export function* getPeriods(api, action) {
  const response = yield call(api.getPeriods, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getPeriodsSuccess(response.data.data));
    } else {
      yield put(actions.getPeriodsFail(response));
    }
  } catch (error) {
    yield put(actions.getPeriodsFail(error));
  }
}
export function* getCourses(api, action) {
  const response = yield call(api.getCourses, action.payload);
  try {
    if (response.ok) {
      const newCourses = FunctionUtils.configYear(response.data.data.edu_courses);
      yield put(actions.getCoursesSuccess(newCourses));
    } else {
      yield put(actions.getCoursesFail(response));
    }
  } catch (error) {
    yield put(actions.getCoursesFail(error));
  }
}
export function* getCourseId(api, action) {
  const response = yield call(api.getCourseId, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getCourseIdSuccess(response.data));
    } else {
      yield put(actions.getCourseIdFail(response));
    }
  } catch (error) {
    yield put(actions.getCourseIdFail(error));
  }
}
export function* getPeriodId(api, action) {
  const response = yield call(api.getPeriodId, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getPeriodIdSuccess(response.data));
    } else {
      yield put(actions.getPeriodIdFail(response));
    }
  } catch (error) {
    yield put(actions.getPeriodIdFail(error));
  }
}
export function* setStatusId(api, action) {
  const response = yield call(api.setStatusId, action.payload);

  try {
    if (response.ok) {
      yield put(actions.setStatusIdSuccess(response.data));
    } else {
      yield put(actions.setStatusIdFail(response));
    }
  } catch (error) {
    yield put(actions.setStatusIdFail(error));
  }
}
export function* getListPeriodId(api, action) {
  const response = yield call(api.getListPeriodId, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getListPeriodIdSuccess(response.data));
    } else {
      yield put(actions.getListPeriodIdFail(response));
    }
  } catch (error) {
    yield put(actions.getListPeriodIdFail(error));
  }
}
export function* getEffectScopes(api, action) {
  const response = yield call(api.getEffectScopes, action.payload);
  try {
    if (response.ok) {
      //const newCourses = FunctionUtils.configYear(response.data.data.evaluation_titles);
      yield put(actions.getEffectScopesSuccess(response.data.data.evaluation_titles));
    } else {
      yield put(actions.getEffectScopesFail(response));
    }
  } catch (error) {
    yield put(actions.getEffectScopesFail(error));
  }
}
export function* getEffectScopesId(api, action) {
  const response = yield call(api.getEffectScopesId, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getEffectScopesIdSuccess(response.data));
    } else {
      yield put(actions.getEffectScopesIdFail(response));
    }
  } catch (error) {
    yield put(actions.getEffectScopesIdFail(error));
  }
}
export function* getCoursesBase(api, action) {
  const response = yield call(api.getCoursesBase, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getCoursesBaseSuccess(response.data.data.edu_courses));
    } else {
      yield put(actions.getCoursesBaseFail(response));
    }
  } catch (error) {
    yield put(actions.getCoursesBaseFail(error));
  }
}
export function* getProvinces(api, action) {
  const response = yield call(api.getProvinces, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getProvincesSuccess(response.data.data.provices));
    } else {
      yield put(actions.getProvincesFail(response));
    }
  } catch (error) {
    yield put(actions.getProvincesFail(error));
  }
}
export function* getDistricts(api, action) {
  const response = yield call(api.getDistricts, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getDistrictsSuccess(response.data.data.districts));
    } else {
      yield put(actions.getDistrictsFail(response));
    }
  } catch (error) {
    yield put(actions.getDistrictsFail(error));
  }
}

export function* getWards(api, action) {
  const response = yield call(api.getDistricts, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getWardsSuccess(response.data.data.ward));
    } else {
      yield put(actions.getWardsFail(response));
    }
  } catch (error) {
    yield put(actions.getWardsFail(error));
  }
}

export function* getListSchool(api, action) {
  const response = yield call(api.getListSchool, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getListSchoolSuccess(response.data.data.schools));
    } else {
      yield put(actions.getListSchoolFail(response));
    }
  } catch (error) {
    yield put(actions.getListSchoolFail(error));
  }
}

export function* getSchoolDetail(api, action) {
  const response = yield call(api.getSchoolDetail, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getSchoolDetailSuccess([response.data.data.school]));
    } else {
      yield put(actions.getSchoolDetailFail(response));
    }
  } catch (error) {
    yield put(actions.getSchoolDetailFail(error));
  }
}

export function* getListSchoolPgd(api, action) {
  const response = yield call(api.getListSchoolPgd, action.payload);
  try {
    if (response.ok) {
      yield put(actions.getListSchoolPgdSuccess(response.data.data.schools));
    } else {
      yield put(actions.getListSchoolPgdFail(response));
    }
  } catch (error) {
    yield put(actions.getListSchoolPgdFail(error));
  }
}

function* getSchoolPgds(action: CommonGetAction) {
  const options = getActionOptions(action.payload.options);

  options.handleLoading(true);
  try {
    const response = yield call(commonHttp.getSchoolPgds, action.payload.data);

    if (!response.ok) {
      throw new Error('Có lỗi xảy ra');
    }

    const data = response.data.data.schools;
    yield put(actions.getSchoolPgdsSuccess(data));
    options.onSuccess(response);
  } catch (error) {
    console.log(error);
    yield put(actions.getSchoolPgdsFail(error));
    options.onFailure(error);
  } finally {
    options.handleLoading(false);
  }
}

function* getEvaluationInitiativesPgds(action: CommonGetAction) {
  const options = getActionOptions(action.payload.options);

  options.handleLoading(true);
  try {
    const response = yield call(commonHttp.getEvaluationInitiativesPgds, action.payload.data);

    if (!response.ok) {
      throw new Error('Có lỗi xảy ra');
    }

    const data = response.data.data.evaluation_intiatives;
    yield put(actions.getEvaluationInitiativesPgdsSuccess(data));
    options.onSuccess(response);
  } catch (error) {
    console.log(error);
    yield put(actions.getEvaluationInitiativesPgdsFail(error));
    options.onFailure(error);
  } finally {
    options.handleLoading(false);
  }
}

export function* setGradeId(api, action) {
  const response = yield call(api.setGradeId, action.payload);

  try {
    if (response.ok) {
      yield put(actions.setGradeIdSuccess(response.data));
    } else {
      yield put(actions.setGradeIdFail(response));
    }
  } catch (error) {
    yield put(actions.setGradeIdFail(error));
  }
}

export function* CommonSaga() {
  yield all([
    yield takeLatest(actions.getPeriods.type, getPeriods, commonHttp),
    yield takeLatest(actions.getCourses.type, getCourses, commonHttp),
    yield takeLatest(actions.getCourseId.type, getCourseId, commonHttp),
    yield takeLatest(actions.getPeriodId.type, getPeriodId, commonHttp),
    yield takeLatest(actions.setStatusId.type, setStatusId, commonHttp),
    yield takeLatest(actions.getListPeriodId.type, getListPeriodId, commonHttp),
    yield takeLatest(actions.getEffectScopes.type, getEffectScopes, commonHttp),
    yield takeLatest(actions.getEffectScopesId.type, getEffectScopesId, commonHttp),
    yield takeLatest(actions.getCoursesBase.type, getCoursesBase, commonHttp),
    yield takeLatest(actions.getProvinces.type, getProvinces, commonHttp),
    yield takeLatest(actions.getDistricts.type, getDistricts, commonHttp),
    yield takeLatest(actions.getWards.type, getWards, commonHttp),
    yield takeLatest(actions.getListSchool.type, getListSchool, commonHttp),
    yield takeLatest(actions.getListSchoolPgd.type, getListSchoolPgd, commonHttp),
    yield takeLatest(actions.getSchoolDetail.type, getSchoolDetail, commonHttp),
    yield takeLatest(actions.setGradeId.type, setGradeId, commonHttp),
    yield takeLatest(actions.getSchoolPgds.type, getSchoolPgds),
    yield takeLatest(actions.getEvaluationInitiativesPgds.type, getEvaluationInitiativesPgds)
  ]);
}
